module.exports = {
  data () {
    return {
      visible: false
    }
  },
  methods: {
    open () {
      this.visible = true
    },
    close () {
      this.visible = false
    }
  },
  template: `
    <click-outside :do="close">
      <div class="relative">
        <div @click="open">
          <slot name="reference"></slot>
        </div>
        <div v-if="visible" class="hero__dropdown" @click="close()">
          <slot></slot>
        </div>
      </div>
    </click-outside>
  `
}